import "./styles.css";
import Header from "./components/Header";
import ColorPalette from "./components/ColorPalette";
import SavedColors from "./components/SavedColors";
import { useState } from "react";

export default function App() {
  const [showSaved, setShowSaved] = useState(false);
  const [savedColors, setSavedColors] = useState([]);
  const [copiedColor, setCopiedColor] = useState(null);
  const [currentPalette, setCurrentPalette] = useState([]);

  const addToSaved = (color) => {
    if (!savedColors.includes(color)) {
      setSavedColors([...savedColors, color]);
    } else deleteFromSaved(color);
  };

  const deleteFromSaved = (colorToDelete) => {
    setSavedColors(savedColors.filter((color) => color !== colorToDelete));
  };

  const copyColor = (color) => {
    navigator.clipboard.writeText(color);
    setCopiedColor(color);
    setTimeout(() => setCopiedColor(null), 2000);
  };

  const generateRandomColor = () => {
    const randomHex =
      "#" + Math.random().toString(16).slice(2, 8).toUpperCase();
    return randomHex;
  };

  const generateNewPalette = () => {
    const newPalette = [];
    newPalette.push(generateRandomColor());
    newPalette.push(generateRandomColor());
    newPalette.push(generateRandomColor());
    setCurrentPalette(newPalette);
  };

  return (
    <div className="App">
      <Header showSaved={showSaved} setShowSaved={setShowSaved} />
      {showSaved ? (
        <SavedColors
          savedColors={savedColors}
          deleteFromSaved={deleteFromSaved}
          copyColor={copyColor}
          copiedColor={copiedColor}
        />
      ) : (
        <>
          <GenerateColors generateNewPalette={generateNewPalette} />
          <ColorPalette
            addToSaved={addToSaved}
            savedColors={savedColors}
            copyColor={copyColor}
            copiedColor={copiedColor}
            currentPalette={currentPalette}
          />
        </>
      )}
    </div>
  );
}

function GenerateColors({ generateNewPalette }) {
  return (
    <div className="generate-section">
      <button className="generate-btn" onClick={generateNewPalette}>
        Generate
      </button>
    </div>
  );
}
